import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import concedidoPqn from "../../assets/concedido-pequeno.png";
import concessionWhite from "../../assets/concessionWhite.png";
import { usePopup } from "../common/Popup";
import apiService from "../../services/api";
import VagaResumoCard from "../Cadastrar-Alunos/VagaResumoCard";
import "../features/users/user-table.css";

const formatTipoAtividade = (tipo) => {
  const tipos = {
    ESTAGIO_OBRIGATORIO: "Estágio Obrigatório",
    ESTAGIO_SUPERVISIONADO: "Estágio Supervisionado",
    INTERNATO_MEDICO: "Internato Médico",
    AULA_PRATICA: "Aula Prática",
  };
  return tipos[tipo] || tipo || "-";
};

const formatDate = (dateValue) => {
  if (!dateValue) return "";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("pt-BR");
};

const formatPeriodo = (periodos = []) => {
  if (!periodos || periodos.length === 0) return "-";
  const normalized = [...periodos].sort(
    (a, b) => new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime()
  );
  return normalized
    .map((periodo) => {
      const inicio = formatDate(periodo.dataInicio);
      const fim = formatDate(periodo.dataFim);
      if (!inicio && !fim) return "";
      if (!inicio) return fim;
      if (!fim) return inicio;
      return `${inicio} - ${fim}`;
    })
    .filter(Boolean)
    .join(" | ");
};

const StatusBar = styled.div`
  font-family: "Public Sans", sans-serif;
  border-top: 1px solid #ccc;
  background-color: #f2f0f0;
  display: flex;
  align-items: center;
  padding: 12px 40px;
  gap: 20px;
`;

const SpecialtyName = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #6ab8a8;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const StatusBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #555555;
  font-weight: 500;

  img {
    width: 28px;
    height: 28px;
  }

  em {
    font-weight: 700;
    color: #2e7d32;
    font-style: italic;
  }
`;

const ConfirmationBoxWrapper = styled.div`
  padding: 20px 20px 0 20px;
  max-width: 700px;
`;

const ConfirmationBox = styled.div`
  border: 2px solid #ff9f1f;
  padding: 18px 22px;
  background: #ffffff;
  font-size: 14px;
  color: #555555;
  line-height: 1.55;
  min-width: 700px;
`;

const ConfirmationParagraph = styled.p`
  margin: 0 0 12px 0;

  strong {
    color: #333333;
  }
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #555555;
  margin-top: 14px;
  cursor: pointer;
  user-select: none;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #ff9f1f;
    cursor: pointer;
  }
`;

const CardOuter = styled.div`
  background: #fff;
  border-top: 1px solid #e0e0e0;
  border-right: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  border-left: none;
  overflow: hidden;
  max-width: 700px;
  margin: 20px 20px 0 0px;
`;

const CardTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #e8f5f3;
  border-bottom: 1px solid #d0d0d0;
  padding-left: 40px;
`;

const UnitInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UnitLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 200px;
`;

const UnitName = styled.div`
  font-size: 16px;
  color: #555555;
  font-weight: 600;
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 20%;
  background: #6ab8a8;
  color: white;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const UnitLabel = styled.div`
  font-size: 16px;
  color: #6ab8a8;
  font-weight: 600;
`;

const FieldRow = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 40px;
  border-bottom: 1px solid #efefef;
  min-height: 42px;

  &:last-child {
    border-bottom: none;
  }
`;

const FieldLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #555555;
  width: 240px;
  flex-shrink: 0;
`;

const FieldValue = styled.div`
  font-size: 16px;
  color: #555;
  flex: 1;
`;

const BottomArea = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  max-width: 700px;
  width: 100%;
  margin: 24px 0 24px 20px;
  padding: 0 20px 0 0;

  .btn-approve,
  .btn-reject {
    padding: 8px 24px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 8px;
    box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
    margin-left: 0;
    justify-content: center;
  }

  .btn-approve:disabled {
    background-color: #9ecec4;
  }
`;

const getInitials = (nome = "") => {
  const parts = nome.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return nome.slice(0, 2).toUpperCase();
};

const FormWrapper = styled.div`
  font-family: "Public Sans", sans-serif;
  padding: 24px 30px 24px 40px;
  max-width: 760px;

  ${({ $fullWidth }) =>
    $fullWidth &&
    `
    max-width: none;
    padding: 0 30px 24px 24px;
  `}
`;

const SplitLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 2fr);
  align-items: start;
  min-height: 400px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const LeftPanel = styled.div`
  padding: 0;
`;

const RightPanel = styled.div`
  min-width: 0;
`;

const SplitFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 20px 40px 28px;
  border-top: 1px solid #e0e0e0;

  .btn-approve {
    padding: 8px 24px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 8px;
    box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
    margin-left: 0;
    justify-content: center;
  }
`;

const VoltarButton = styled.button`
  background-color: #999;
  color: #ffffff;
  border: none;
  padding: 8px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  &:hover {
    background-color: #888;
  }
`;

const FormHeader = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #ff9f1f;
  margin-bottom: 12px;
  padding-top: ${({ $alignTop }) => ($alignTop ? "12px" : "0")};
`;

const PreencherDepoisButton = styled.button`
  background: #6ab8a8;
  color: #ffffff;
  border: none;
  padding: 10px 22px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  margin-bottom: 18px;

  &:hover {
    background: #5da89a;
  }
`;

const FieldGroup = styled.div`
  margin-bottom: 14px;
`;

const FormLabel = styled.label`
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 4px;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #b9b9b9;
  border-radius: 6px;
  font-size: 15px;
  color: #555555;
  background: #ffffff;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #6ab8a8;
  }
`;

const InlineRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  > ${FormLabel} {
    width: 22px;
    margin-bottom: 0;
    font-weight: 700;
  }

  > ${FormInput} {
    flex: 1;
  }
`;

const TwoColumnRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 14px;
`;

const DaysWrapper = styled.div`
  margin-bottom: 18px;
`;

const DaysList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 6px;
`;

const DayLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  color: #555555;
  user-select: none;

  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #4a4a4a;
    border-radius: 2px;
    background: #ffffff;
    position: relative;
    cursor: default;
    margin: 0;
  }

  input[type="checkbox"]:checked {
    background: #6ab8a8;
    border-color: #4a4a4a;
  }

  input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 1px;
    width: 4px;
    height: 8px;
    border: solid #000000;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  input[type="checkbox"]:disabled {
    opacity: 1;
  }
`;

const HelpText = styled.p`
  font-size: 14px;
  color: #555555;
  line-height: 1.55;
  margin: 18px 0 0 0;

  em {
    color: #6ab8a8;
    font-style: italic;
    font-weight: 600;
  }

  strong {
    color: #333333;
  }
`;

const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

const AddAtividadeButton = styled.button`
  background: #6ab8a8;
  color: #ffffff;
  border: none;
  height: 32px;
  font-size: 14px;
  padding: 0 12px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;

  &:hover {
    background: #5da89a;
  }
`;

const AtividadeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  > ${FormInput} {
    flex: 1;
  }
`;

const ProximoButton = styled.button`
  background: #6ab8a8;
  color: #ffffff;
  border: none;
  padding: 10px 26px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #5da89a;
  }
`;

const PopupIconRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;

  img {
    width: 48px;
    height: 48px;
  }

  img.check {
    width: 36px;
    height: 36px;
  }
`;

const DIAS_SEMANA = [
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
  "Domingo",
];

const normalizeDia = (s = "") =>
  s
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const ConfirmarConcessaoDetalhe = ({ solicitacao, onVoltar, modoConfirmada = false }) => {
  const popup = usePopup();
  const navigate = useNavigate();
  const [acceptedTerm, setAcceptedTerm] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [loadingDados, setLoadingDados] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    instituicaoCurricular: "",
    apolice: "",
    seguradora: "",
    vigenciaInicio: "",
    vigenciaFim: "",
  });
  const [atividades, setAtividades] = useState([""]);

  const handleFieldChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleAtividadeChange = (index) => (e) => {
    const value = e.target.value;
    setAtividades((prev) => prev.map((item, i) => (i === index ? value : item)));
  };

  const handleAddAtividade = () => {
    setAtividades((prev) => [...prev, ""]);
  };

  useEffect(() => {
    if ((!showForm && !modoConfirmada) || !solicitacao?.id) return;

    const loadDados = async () => {
      setLoadingDados(true);
      try {
        const dados = await apiService.getDadosEstagio(solicitacao.id);
        if (dados) {
          setFormData({
            instituicaoCurricular: dados.instituicaoCurricular || "",
            apolice: dados.apoliceNumero || "",
            seguradora: dados.seguradoraNome || "",
            vigenciaInicio: dados.seguroVigenciaInicio
              ? dados.seguroVigenciaInicio.slice(0, 10)
              : "",
            vigenciaFim: dados.seguroVigenciaFim
              ? dados.seguroVigenciaFim.slice(0, 10)
              : "",
          });
          const descricoes = (dados.atividades || []).map((a) => a.descricao);
          setAtividades(descricoes.length > 0 ? descricoes : [""]);
        }
      } catch (err) {
        console.error("Erro ao carregar dados de estágio:", err);
      } finally {
        setLoadingDados(false);
      }
    };

    loadDados();
  }, [showForm, modoConfirmada, solicitacao?.id]);

  const diasSelecionados = (solicitacao?.diasSemana || []).map((d) =>
    normalizeDia(typeof d === "string" ? d : d?.diaSemana)
  );

  const vaga = solicitacao?.vaga || {};
  const especialidade =
    vaga.unidadeAssistencial?.especialidade?.nome || "Vaga";
  const unidadeNome = vaga.estabelecimentoSaude?.nome || "-";
  const curso =
    vaga.areaCurso?.nome || solicitacao.curso?.curso || "-";
  const setor = vaga.unidadeAssistencial?.nome || "-";
  const periodo = formatPeriodo(solicitacao.periodos);
  const turno = vaga.turno || "-";
  const qtdAlunos =
    solicitacao.quantidadeAlunosConcedidos ??
    solicitacao.quantidadeAlunos ??
    null;
  const horasPorAluno = solicitacao.horasTotaisPorAluno ?? null;
  const totalHoras =
    qtdAlunos !== null && horasPorAluno !== null
      ? Number(qtdAlunos) * Number(horasPorAluno)
      : null;

  const handleConfirmar = async () => {
    const confirmed = await popup.confirm({
      icon: (
        <PopupIconRow>
          <img src={concessionWhite} alt="Concessão" />
        </PopupIconRow>
      ),
      message:
        "Ao confirmar, você deverá cadastrar os dados do estágio e cadastrar os alunos vinculados a esta vaga. Deseja confirmar a concessão?",
      confirmText: "Confirmar",
      cancelText: "Cancelar",
    });
    if (!confirmed) return;

    try {
      await apiService.confirmarSolicitacaoVaga(solicitacao.id);
      setShowForm(true);
    } catch (err) {
      await popup.alert({
        icon: "warning",
        title: "Erro ao confirmar",
        message: err.message || "Tente novamente.",
      });
    }
  };

  const handlePreencherDepois = async () => {
    await popup.alert({
      icon: (
        <PopupIconRow>
          <img src={concessionWhite} alt="Concessão" />
        </PopupIconRow>
      ),
      message:
        "Você poderá retornar para cadastrar os dados do estágio e os alunos. Acesse o menu lateral CONCESSÕES > Cadastrar Alunos.",
      confirmText: "ok",
    });
    if (typeof onVoltar === "function") onVoltar();
    navigate("/CadastrarAlunos", { replace: true });
  };

  const hasFormData = () => {
    const hasAtividade = atividades.some((a) => a.trim().length > 0);
    return (
      formData.instituicaoCurricular.trim() ||
      formData.apolice.trim() ||
      formData.seguradora.trim() ||
      formData.vigenciaInicio ||
      formData.vigenciaFim ||
      hasAtividade
    );
  };

  const buildPayload = () => {
    const payload = {
      instituicaoCurricular: formData.instituicaoCurricular.trim() || undefined,
      apoliceNumero: formData.apolice.trim() || undefined,
      seguradoraNome: formData.seguradora.trim() || undefined,
      atividades: atividades.filter((a) => a.trim().length > 0),
    };
    if (formData.vigenciaInicio) {
      payload.seguroVigenciaInicio = new Date(formData.vigenciaInicio).toISOString();
    }
    if (formData.vigenciaFim) {
      payload.seguroVigenciaFim = new Date(formData.vigenciaFim).toISOString();
    }
    return payload;
  };

  const handleSalvar = async () => {
    if (!modoConfirmada && !hasFormData()) {
      navigate("/CadastrarAlunos");
      return;
    }

    setSaving(true);
    try {
      await apiService.saveDadosEstagio(solicitacao.id, buildPayload());
      await popup.alert({
        icon: "success",
        title: "Dados do estágio salvos com sucesso.",
        message: "Você deve cadastrar os alunos que ocuparão as vagas.",
        confirmText: "OK",
      });
      navigate("/CadastrarAlunos", {
        state: {
          solicitacaoId: solicitacao.id,
          vagaId: solicitacao.vaga?.id ?? solicitacao.vagaId,
        },
      });
    } catch (err) {
      await popup.alert({
        icon: "warning",
        title: "Erro ao salvar",
        message: err.message || "Tente novamente.",
      });
    } finally {
      setSaving(false);
    }
  };

  const renderFormularioEstagio = ({ showPreencherDepois = true, fullWidth = false } = {}) => (
    <FormWrapper $fullWidth={fullWidth}>
      <FormHeader $alignTop={fullWidth}>Preencha os dados</FormHeader>
      {showPreencherDepois && (
        <PreencherDepoisButton type="button" onClick={handlePreencherDepois}>
          Preencher depois
        </PreencherDepoisButton>
      )}

      <FieldGroup>
        <FormLabel htmlFor="instituicaoCurricular">Fase curricular</FormLabel>
        <FormInput
          id="instituicaoCurricular"
          type="text"
          value={formData.instituicaoCurricular}
          onChange={handleFieldChange("instituicaoCurricular")}
        />
      </FieldGroup>

      <FieldGroup>
        <FormLabel>Atividades a serem desenvolvidas*</FormLabel>
        {atividades.map((atividade, index) => (
          <AtividadeRow key={`atividade-${index}`}>
            <FormInput
              type="text"
              value={atividade}
              onChange={handleAtividadeChange(index)}
              placeholder={`Atividade ${index + 1}`}
            />
          </AtividadeRow>
        ))}
        <AddAtividadeButton type="button" onClick={handleAddAtividade}>
          Adicionar atividade +
        </AddAtividadeButton>
      </FieldGroup>

      <TwoColumnRow>
        <div>
          <FormLabel htmlFor="apolice">Nº da apólice de seguro*</FormLabel>
          <FormInput
            id="apolice"
            type="text"
            value={formData.apolice}
            onChange={handleFieldChange("apolice")}
          />
        </div>
        <div>
          <FormLabel htmlFor="seguradora">Nome da seguradora*</FormLabel>
          <FormInput
            id="seguradora"
            type="text"
            value={formData.seguradora}
            onChange={handleFieldChange("seguradora")}
          />
        </div>
      </TwoColumnRow>

      <TwoColumnRow>
        <div>
          <FormLabel htmlFor="vigenciaInicio">
            Período de vigência do seguro (Início)*
          </FormLabel>
          <FormInput
            id="vigenciaInicio"
            type="date"
            value={formData.vigenciaInicio}
            onChange={handleFieldChange("vigenciaInicio")}
          />
        </div>
        <div>
          <FormLabel htmlFor="vigenciaFim">
            Período de vigência do seguro (Término)*
          </FormLabel>
          <FormInput
            id="vigenciaFim"
            type="date"
            value={formData.vigenciaFim}
            onChange={handleFieldChange("vigenciaFim")}
          />
        </div>
      </TwoColumnRow>

      <DaysWrapper>
        <FormLabel as="span">Dias da semana</FormLabel>
        <DaysList>
          {DIAS_SEMANA.map((dia) => (
            <DayLabel key={dia}>
              <input
                type="checkbox"
                checked={diasSelecionados.includes(normalizeDia(dia))}
                disabled
                readOnly
              />
              {dia}
            </DayLabel>
          ))}
        </DaysList>
      </DaysWrapper>

      {!modoConfirmada && (
        <HelpText>
          Após clicar em <em>Salvar</em> você será direcionado para realizar o{" "}
          <strong>Cadastro de Alunos</strong>. Caso queira finalizar o cadastro
          posteriormente, estes dados ficarão salvos. Basta acessar o menu{" "}
          <strong>Cadastrar Alunos</strong> novamente.
        </HelpText>
      )}

      {!modoConfirmada && (
        <FormFooter>
          <ProximoButton
            type="button"
            onClick={handleSalvar}
            disabled={saving || loadingDados}
          >
            {saving ? "Salvando..." : "Salvar"}
          </ProximoButton>
        </FormFooter>
      )}
    </FormWrapper>
  );

  if (modoConfirmada) {
    return (
      <>
        <StatusBar>
          <SpecialtyName>{especialidade}</SpecialtyName>
          <StatusBlock>
            <img src={concedidoPqn} alt="Confirmada" />
            <span>
              Vaga <em>confirmada</em>
            </span>
          </StatusBlock>
        </StatusBar>

        <SplitLayout>
          <LeftPanel>
            <VagaResumoCard solicitacao={solicitacao} wide />
          </LeftPanel>
          <RightPanel>
            {renderFormularioEstagio({ showPreencherDepois: false, fullWidth: true })}
          </RightPanel>
        </SplitLayout>

        <SplitFooter>
          <VoltarButton type="button" onClick={onVoltar}>
            Voltar
          </VoltarButton>
          <button
            type="button"
            className="btn-approve"
            onClick={handleSalvar}
            disabled={saving || loadingDados}
          >
            {saving ? "Salvando..." : "Salvar"}
          </button>
        </SplitFooter>
      </>
    );
  }

  if (showForm) {
    return (
      <>
        <StatusBar>
          <SpecialtyName>{especialidade}</SpecialtyName>
          <StatusBlock>
            <img src={concedidoPqn} alt="Concedido" />
            <span>
              Vaga <em>concedida</em> pelo NEPS
            </span>
          </StatusBlock>
        </StatusBar>

        {renderFormularioEstagio()}
      </>
    );
  }

  return (
    <>
      <StatusBar>
        <SpecialtyName>{especialidade}</SpecialtyName>
        <StatusBlock>
          <img src={concedidoPqn} alt="Concedido" />
          <span>
            Vaga <em>concedida</em> pelo NEPS
          </span>
        </StatusBlock>
      </StatusBar>

      <ConfirmationBoxWrapper>
        <ConfirmationBox>
          <ConfirmationParagraph>
            Agradecemos por escolher a SES/SC como campo para o Estágio
            Obrigatório. Esperamos que esta experiência seja enriquecedora e
            ofereça contribuições significativas para os seus alunos.
          </ConfirmationParagraph>
          <ConfirmationParagraph>
            Lembramos que qualquer alteração na carga horária deve ser
            comunicada, via Sistema, com{" "}
            <strong>antecedência mínima de 30 dias</strong>. O não cumprimento
            dessa obrigação resultará na cobrança da contrapartida referente à
            carga horária total concedida. A concessão pode ser rescindida
            unilateralmente, mediante aviso prévio de 30 dias, e as partes
            poderão formalizar uma nova concessão com a mesma antecedência. Ao
            final do estágio, a SES/SC solicitará a contrapartida conforme
            estipulado no TCT.
          </ConfirmationParagraph>
          <CheckboxLabel>
            <input
              type="checkbox"
              checked={acceptedTerm}
              onChange={(e) => setAcceptedTerm(e.target.checked)}
            />
            Estou ciente do prazo de desistência.
          </CheckboxLabel>
        </ConfirmationBox>
      </ConfirmationBoxWrapper>

      <VagaResumoCard solicitacao={solicitacao} />

      <BottomArea>
        <button type="button" className="btn-reject" onClick={onVoltar}>
          Não confirmar ✕
        </button>
        <button
          type="button"
          className="btn-approve"
          onClick={handleConfirmar}
          disabled={!acceptedTerm}
        >
          Confirmar ✓
        </button>
      </BottomArea>
    </>
  );
};

export default ConfirmarConcessaoDetalhe;
